module.exports = __webpack_public_path__ + "img/img_promotion_bnr_kt.edc22aeb.png";